import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"; // Detecção automática de idioma
import Backend from "i18next-http-backend"; // Carregamento assíncrono de traduções

// Configuração do i18next
i18n
  .use(Backend) // Usando o backend para carregar arquivos de tradução
  .use(LanguageDetector) // Usando o detector de linguagem
  .use(initReactI18next) // Integrando com o React
  .init({
    lng: "pt", // Força o idioma inicial como Português
    fallbackLng: "pt", // Idioma de fallback
    debug: true, // Habilitando para debug no console

    interpolation: {
      escapeValue: false, // Não escapar valores, já que o React lida com segurança
    },
    react: {
      useSuspense: true, // Habilita Suspense para aguardar o carregamento das traduções
    },
  });

export default i18n;
